const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Video Image component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */

app.directive('addTags', [
  'Application',
  'appConfiguration',
  '$http',
  function (Application, appConfiguration, $http) {
    return {
      restrict: 'E',
      replace: false,
      scope: {
        source: '=',
        tags: '=',
        instructions: '=',
        onChange: '&?',
      },
      template: require('../../../templates/directives/cms/add-tags.html'),
      link: function (scope, element, attrs) {
        scope.generativeInProgress = false;
        scope.generativeEnabled = Application.features.flags().enable_generative_ai;
        scope.editTag = {
          newTag: '',
          addTags: function (keyPress) {
            if ((keyPress !== 'click' && keyPress.which !== 13) || !this.newTag) {
              return;
            }

            if (!scope.tags) {
              scope.tags = [];
            }

            scope.tags.push(this.newTag);
            this.newTag = '';
            if (scope.onChange) {
              scope.onChange();
            }
          },
          generateTags: function () {
            if (scope.generativeInProgress) {
              return;
            }
            scope.generativeInProgress = true;
            $http
              .post(appConfiguration.apiUrl + '/graphql', {
                query:
                  'query { generativeKeywords(text:"' +
                  scope.source.trim().replaceAll('\n', '').replaceAll('"', '') +
                  '") }',
              })
              .then(function (resp) {
                if (!scope.tags) {
                  scope.tags = [];
                }
                resp.data.data.generativeKeywords.forEach(function (tag) {
                  if (scope.tags.indexOf(tag) === -1) {
                    scope.tags.push(tag);
                  }
                });
                if (scope.onChange) {
                  scope.onChange();
                }
                scope.generativeInProgress = false;
              })
              .catch(function (error) {
                console.log('Error occured getting generativeKeywords ', error);
                scope.generativeInProgress = false;
              });
          },
          removeTag: function (index) {
            scope.tags.splice(index, 1);
            if (scope.onChange) {
              scope.onChange();
            }
          },
        };
      },
    };
  },
]);
